import { render, staticRenderFns } from "./ordersettingnotifyuser.vue?vue&type=template&id=1e4751e7&"
import script from "./ordersettingnotifyuser.vue?vue&type=script&lang=js&"
export * from "./ordersettingnotifyuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports